export const BNPP = 'with_opt_out';
export const MERCK = 'merck';
export const DEFAULT = 'default';
